module.exports = __webpack_public_path__ + "img/gov1.1fb4f01b.png";